import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class AcertosDiversosApi extends Api {
  async consultarTodosOsProtocolos () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosProtocolosAcertosDiversos');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarAcertos (numProtocolo, numMatricula, codEstado, codTipo, numProcesso, anoProcesso, dataInicial, dataFinal) {
    let acertos = [];
    let brancoAcoes = '';
    try {
      const acertoUrl = resolve('urlConsultarAcertosDiversos') +
      numProtocolo + '/' +
      numMatricula + '/' +
      codEstado + '/' +
      codTipo + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal;
      const { data } = await this.fetch(acertoUrl, 'post');
      data.map(res => {
        const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codEstado, desEstado, codTipo, desTipo, txtObservacao, dtaCadastro, numProcesso, anoProcesso, codUsuario, nomUsuario, txtProcessoSei } = res;
        const numAnoProc = numProcesso + '/' + anoProcesso;
        acertos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codEstado, desEstado, codTipo, desTipo, txtObservacao, dtaCadastro, numAnoProc, anoProcesso, numProcesso, codUsuario, nomUsuario, txtProcessoSei, brancoAcoes }));
      });
      return acertos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async incluirAcerto (acerto) {
    try {
      const urlIncluirAcerto = resolve('urlIncluirAcertosDiversos');
      const response = await this.fetch(urlIncluirAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarAcerto (acerto) {
    try {
      const urlAlterarAcerto = resolve('urlAlterarAcertosDiversos');
      const response = await this.fetch(urlAlterarAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcertosEmLote (acertos) {
    try {
      const urlExcluirAcertos = resolve('urlExcluirAcertosDiversosEmLote');
      const result = await this.fetch(urlExcluirAcertos, 'post', acertos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async processarAcerto (numProtocolo) {
    try {
      const urlProcessarAcerto = resolve('urlProcessarAcertosDiversos') + numProtocolo;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcerto (numProtocolo) {
    try {
      const urlExcluirAcerto = resolve('urlExcluirAcertosDiversos') + numProtocolo;
      const response = await this.fetch(urlExcluirAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AcertosDiversosApi;
